import ChartInDialogButton from "components/basic/chart-in-dialog-button/ChartInDialogButton";
import {IDatasetTableDefaultProps} from "components/dashboard/dataset-table/utils/interfaces";
import {WIDTH_LOOKUP_TABLE} from "components/dashboard/dataset-table/utils/utils";
import React, {ReactNode} from "react";
import {TitleOverrideAndDescriptionTemplate} from "components/templates/DataTableCellTemplates";
import {Tooltip} from "react-tooltip";
import {ChronoUnitLegacy, dateToReadableString} from "utils/time-utils";

const DatasetTableDefault = ({config, dateFrom, dateTo, data, datasetsArray, getCellStyle, totals, setIsDialogOpen}: IDatasetTableDefaultProps) => {

    const showTotal = datasetsArray.some(obj => obj.showTotal)
    const ColumnHeader = () => {
        return <tr>
            {!config?.hideDateColumn &&
                <th style={{
                    padding: "2px 8px",
                    width: WIDTH_LOOKUP_TABLE[config?.dateFormat || ChronoUnitLegacy.MINUTES]
                }}>
                    Date
                </th>
            }
            {datasetsArray?.map((col: any, i: number) => {
                return <th key={i}
                           style={{padding: "2px 8px"}}
                >{TitleOverrideAndDescriptionTemplate({
                        description: col.description,
                        title: col.title,
                        overriddenTitle: col.overriddenTitle,
                        unit: col.unit,
                        identifier: col.identifier
                    },
                    2)}
                    <div className={"non-printable"}>
                        <ChartInDialogButton dateFrom={dateFrom} dateTo={dateTo} identifier={col.identifier} setIsDialogOpen={setIsDialogOpen}/>
                    </div>
                </th>
            })
            }
        </tr>

    }

    const ColumnFooter = () => {
        return (
            <tr>
                <th scope="row"></th>
                {totals.length > 0 ? totals.map(obj => {
                    if(obj.value){
                        return <td className="value-class" key={obj.identifier}><Tooltip id="value-tooltip" opacity={0.7} place="top" float /><span data-tooltip-id="value-tooltip" data-tooltip-content={`${obj.tooltip}`} >{obj.value}</span></td>
                    } else {
                        return <td className="value-class" key={obj.identifier}></td>
                    }
                }) :  <td className="value-class"></td> }
            </tr>
        )
    }

    const dateBody = (date: string): string => {
        const dateDate = new Date(date);
        const dateFormat = config?.dateFormat || "MINUTES";
        return dateToReadableString(dateDate, dateFormat as ChronoUnitLegacy);
    }

    const columnBody = data.map((obj: any, index: number): ReactNode => {
            if (config?.transposed) {
                return (<tr key={index}></tr>)
            }
            return (<tr key={index}>
                {!config?.hideDateColumn &&
                    <td style={{
                        whiteSpace: "nowrap",
                        padding: "2px 8px"
                    }}>
                        {dateBody(obj.date)}
                    </td>
                }
                {Object.entries(obj).map(([key, value], index) => {
                    if (key !== "date") {
                        return <td key={index} className={"value-class"} style={getCellStyle(key, value)}>
                            {value || value === 0 ?
                                datasetsArray[index].decimalPlaces != null ?
                                    <>{(value as number).toFixed(datasetsArray[index].decimalPlaces)}</>
                                    :
                                    <>{(value as number).toFixed(2)}</>
                                :
                                "-"
                            }</td>
                    }
                })}
            </tr>)
        }
    )

    return <div className={"data-table-wrapper default-table"}>
        <table className={"min-table-width"}>
            <thead>
            <ColumnHeader/>
            </thead>
            <tbody>
            {columnBody}
            </tbody>
            {showTotal && (<tfoot>
            <ColumnFooter />
            </tfoot>)}
        </table>
    </div>
};

export default DatasetTableDefault;